const tmp = typeof settings === "undefined" ? {} : settings;

export default _.map(_.get(tmp, 'filter', []), (filter) => {
    return {
        url: filter.url.substring(1, filter.url.length - 1),
        services: filter.ids,
        features: filter.features
    }
});
